import React from "react";
import { LIFECYCLE_LABELS } from "../../model/domain/definitions";

export const ProjectStatusToggle: React.FC<{
  isExisting: boolean;
  onChange: (existing: boolean) => void;
}> = ({ isExisting, onChange }) => (
  <section>
    <h4 className="mb-3 text-body font-semibold text-quantum-400">Project Status</h4>
    <div className="flex gap-6">
      <label className={`flex items-center gap-2 text-body-sm font-medium cursor-pointer px-4 py-2 rounded-lg border transition-colors ${
        !isExisting
          ? 'bg-quantum-500/20 border-quantum-500/40 text-quantum-400'
          : 'bg-surface-600 border-border text-text-secondary hover:border-quantum-500/30'
      }`}>
        <input
          type="radio"
          name="proj_status"
          value="prospective"
          className="accent-quantum-500"
          checked={!isExisting}
          onChange={() => onChange(false)}
        />
        {LIFECYCLE_LABELS.prospective}
      </label>
      <label className={`flex items-center gap-2 text-body-sm font-medium cursor-pointer px-4 py-2 rounded-lg border transition-colors ${
        isExisting
          ? 'bg-quantum-500/20 border-quantum-500/40 text-quantum-400'
          : 'bg-surface-600 border-border text-text-secondary hover:border-quantum-500/30'
      }`}>
        <input
          type="radio"
          name="proj_status"
          value="operating"
          className="accent-quantum-500"
          checked={isExisting}
          onChange={() => onChange(true)}
        />
        {LIFECYCLE_LABELS.operating}
      </label>
    </div>
  </section>
);
